'use strict';

import register from './core';
import '../functions/jquery-global.js';
import { trackLink } from '../functions/common';

register('scroll-depth', function (element) {
  var $window = $(window),
    cache = [],
    scrollEventBound = false;

    var defaults = {
      minHeight: 0,
      percentage: true,
      userTiming: true,
      pixelDepth: true
    };
    var startTime = +new Date,
      options = $.extend({}, defaults, options);

  function calculateMarks(docHeight) {
    return {
      '15': parseInt(docHeight * 0.15, 10),
      '25': parseInt(docHeight * 0.25, 10),
      '50': parseInt(docHeight * 0.50, 10),
      '90': parseInt(docHeight * 0.90, 10),
      // Cushion to trigger 100% event in iOS
      '100': docHeight - 5
    };
  }

  function sendEvent(action, label, scrollDistance, timing) {
    trackLink('sz', 'Scroll', 'Scroll Depth', label);
    //console.log(action + ' ' + label + ' scrollDistance: ' + scrollDistance);
  }

  function checkMarks(marks, scrollDistance, timing) {
    // Check each active mark
    $.each(marks, function (key, val) {
      if ($.inArray(key, cache) === -1 && scrollDistance >= val) {
        sendEvent('Percentage', key, scrollDistance, timing);
        cache.push(key);
      }
    });
  }

  function init() {
    bindScrollDepth();
  }

  function throttle(func, wait) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    var later = function () {
      previous = new Date;
      timeout = null;
      result = func.apply(context, args);
    };
    return function () {
      var now = new Date;
      if (!previous) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }

  function bindScrollDepth() {

    scrollEventBound = true;

    $window.on('scroll.scrollDepth', throttle(function () {
      /*
       * We calculate document and window height on each scroll event to
       * account for dynamic DOM changes.
       */

      var docHeight = $(document).height(),
        winHeight = window.innerHeight ? window.innerHeight : $window.height(),
        scrollDistance = $window.scrollTop() + winHeight,

        // Recalculate percentage marks
        marks = calculateMarks(docHeight),

        // Timing
        timing = +new Date - startTime;

      // If all marks already hit, unbind scroll event
      if (cache.length >=  (options.percentage ? 4 : 0)) {
        $window.off('scroll.scrollDepth');
        scrollEventBound = false;
        sendEvent('Percentage', 100, scrollDistance, timing);
        return;
      }

      // Check standard marks
      if (options.percentage) {
        checkMarks(marks, scrollDistance, timing);
      }
    }, 500));

  }

  init();
})
